import isEmpty from "lodash/isEmpty";
import orderBy from "lodash/orderBy";
// components
import RMDRTextSanitizer from "@/components/RMDRTextSanitizer";
import RMDRAccordion01 from "@/components/RMDRAccordions/components/RMDRAccordion01";
import RMDRTab01 from "@/components/RMDRTabs/components/RMDRTab01";
// enums
import EView from '@/cms/enums/EView';
import EContentType from '@/cms/enums/EContentType';
// utilities
import LanguageVersionSelector from "@/utilities/LanguageVersionSelector";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";

import IDetailLanguageVersion from "@/cms/types/TLanguageVersionDetail"
import IListLanguageVersion from "@/cms/types/TLanguageVersionList"


type TContentRenderer = {

    languageVersions?: IListLanguageVersion[]|IDetailLanguageVersion[]|null;

}

const ContentRenderer = ( props:TContentRenderer ) => {

    if ( props.languageVersions && !isEmpty(props.languageVersions) ) {

        let parentLanguageVersions = LanguageVersionSelector<TLanguageVersionList[]|TLanguageVersionDetail[]|null>({
            languageVersions: props.languageVersions,
            filters: [
                { view: EView.INNER, contentType: EContentType.DEFAULT, customFilter:[ { key: "parentId", value: null } ] }
            ],
            type: 'filter'
        });

        parentLanguageVersions = orderBy(parentLanguageVersions, ['order'],['asc']);

        return (
            <>
                {
                    parentLanguageVersions.map(
                        (item) => <>
                            <RMDRTextSanitizer parentLanguageVersion={item} languageVersions={props.languageVersions} />
                            <RMDRAccordion01 parentLanguageVersion={item} languageVersions={props.languageVersions} />
                            <RMDRTab01 parentLanguageVersion={item} languageVersions={props.languageVersions} />
                        </> 
                    )
                }
            </>
        )

    }

    return null;

}

export default ContentRenderer;
export type {
    TContentRenderer
};